module.exports = __webpack_public_path__ + "static/img/ext6.1f28eebc.jpg";